import { UNIT_TYPES } from '@/utils/constants'
import unitTypeMixin from '@/mixins/unit-types'

export default {
  name: 'oz-unit-types',

  props: {
    glossary: { type: Object, required: true },
    unitTypes: { type: [Object, String], default: UNIT_TYPES.UNIT_TYPE_DEFAULT },
    listingType: { type: String, required: true },
  },

  mixins: [unitTypeMixin],
}
